export enum MigrationVersionEnum {
  'v1_0_0' = '1.0.0',
  'v2_0_0' = '2.0.0',
  'v3_0_0' = '3.0.0',
  'v4_0_0' = '4.0.0',
  'v4_1_0' = '4.1.0',
}

export interface MigrationState {}

export interface MigrationVersionState {
  version: MigrationVersionEnum;
  state: MigrationState;
}

export interface MigrationVersionStateV1_0_0 {
  version: MigrationVersionEnum.v1_0_0;
  state: {};
}

export interface MigrationVersionStateV2_0_0 {
  version: MigrationVersionEnum.v2_0_0;
  state: {};
}

export interface MigrationVersionStateV3_0_0 {
  version: MigrationVersionEnum.v3_0_0;
  state: {};
}

export interface MigrationVersionStateV4_0_0 {
  version: MigrationVersionEnum.v4_0_0;
  state: {};
}

export interface MigrationVersionStateV4_1_0 {
  version: MigrationVersionEnum.v4_1_0;
  state: {};
}

export type MigrationVersionStates =
  | MigrationVersionStateV1_0_0
  | MigrationVersionStateV2_0_0
  | MigrationVersionStateV3_0_0
  | MigrationVersionStateV4_0_0
  | MigrationVersionStateV4_1_0;

export type Migration<TVersion extends MigrationVersionEnum, TIn, TOut> = {
  /**
   * The version of the migration
   */
  version: TVersion;
  /**
   * Check if the migration must be applied to the state
   */
  check: (state: TIn) => boolean;
  /**
   * Migrate the state to the next version
   */
  migrate: (state: TIn) => TOut;
};
